import { createFileRoute, redirect } from "@tanstack/react-router";
import ProjectsHub from "../../../pages/Admin/ProjectsHub";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";

export const Route = createFileRoute("/_admin/projects/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  pendingComponent: () => <PageSkeleton rows={6} variant="cards" />,
  errorComponent: createRouteError("Projects"),
  component: ProjectsHub,
});
